export default "<app-request-status [status]=\"status\"></app-request-status>\n"